import { allTrackers } from "app/services/track/track";

import createMyListTrackingService from "./factory";

export default createMyListTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));
